import { useMemo } from 'react';

import { Logger } from '@farmersdog/logger';

import { useQueryParams } from '../../components/NewTosaRouter/hooks/useQueryParams';

import { validateReferredByVet } from './validateReferredByVet';

export function useReferredByVetUrlParam() {
  const searchParams = useQueryParams();
  const referredByVetParam = searchParams.get('referredByVet');

  const validatedReferredByVetUrlParam = useMemo(() => {
    if (referredByVetParam) {
      try {
        const parsedParam = JSON.parse(referredByVetParam) as unknown;
        return validateReferredByVet(parsedParam);
      } catch (error) {
        const logger = new Logger('tosa:frontend:vet:useReferredByVetUrlParam');
        logger.error('Failed to parse url param', {
          error,
          referredByVetParam,
        });
        return null;
      }
    }

    return null;
  }, [referredByVetParam]);

  return validatedReferredByVetUrlParam;
}
